import Hotjar from 'vue-hotjar'

import type { UserModule } from '~/types'

export const install: UserModule = (app) => {
  if (import.meta.env.VITE_APP_HOTJAR_ENABLED === 'true')
    app.use (Hotjar, { id: import.meta.env.VITE_APP_HOTJAR_SITE_ID })
}

export default { install }
